export const BASE_URL = process.env.REACT_APP_API_BASE_PATH as string;
export const API_URL = `${BASE_URL}/api`;

export const IMG_LOCATION = process.env.REACT_APP_IMG_LOCATION as string;
export const FILE_LOCATION = process.env.REACT_APP_FILE_LOCATION as string;
